import React, { useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useStore } from '../../../store';
import { IInputValue } from '../../../domains/common.domain';
import useRegisterErrorField from '../hooks/register-error-field-hook';

interface IStringInputProps {
  value: IInputValue<string> | IInputValue<string | null>;
  label: string;
  name: string;
  error?: string;
  onUpdate: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
  maxLength?: number;
  onPaste?: (event: any) => void;
  placeholder?: string;
}

const StringInput = observer((props: IStringInputProps) => {
  const { value, label, error = '', onUpdate, onBlur, disabled = false, maxLength, name, onPaste, placeholder } = props;
  const { signUpStore } = useStore();
  const fieldRef = useRef<HTMLDivElement | null>(null);
  useRegisterErrorField(fieldRef, value.errorType);

  return (
    <div className={'container-input'} ref={fieldRef}>
      <label>{label}</label>
      <div className={'controls'}>
        <input
          type="text"
          className={classNames(value.errorType && signUpStore.showErrors && 'error')}
          value={value.value ?? ''}
          name={name}
          onChange={e => onUpdate(e.target.value)}
          disabled={disabled}
          onBlur={() => onBlur && onBlur()}
          maxLength={maxLength}
          onPaste={onPaste}
          placeholder={placeholder}
        />
        {error && value?.errorType && signUpStore.showErrors && <label className={'error'}>{error}</label>}
      </div>
    </div>
  );
});

export default StringInput;
